import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyA_9g7bSY6pBenJALeIBLETP-fxiJ-3ATA",
//   authDomain: "sand-app-c8d59.firebaseapp.com",
//   projectId: "sand-app-c8d59",
//   storageBucket: "sand-app-c8d59.firebasestorage.app",
//   messagingSenderId: "983817358374",
//   appId: "1:983817358374:web:6964460eeed762f4fdeae7",
//   measurementId: "G-RC8VL04GZH",
// };

const firebaseConfig = {
  apiKey: "AIzaSyD8bg0l_iUDnrTvVzgcFFr-TqEZDqOfvsE",
  authDomain: "sanad-plus-4432f.firebaseapp.com",
  projectId: "sanad-plus-4432f",
  storageBucket: "sanad-plus-4432f.firebasestorage.app",
  messagingSenderId: "760294630503",
  appId: "1:760294630503:web:13dfaaf425d71f689e20c2",
  measurementId: "G-9PPKW0S6WS",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// export const requestNotificationPermission = async () => {
//   try {
//     const token = await getToken(messaging, {
//       vapidKey: "AIzaSyD8bg0l_iUDnrTvVzgcFFr-TqEZDqOfvsE",
//     });
//     return token;
//   } catch (err) {
//     console.error("FCM token error:", err);
//     return null;
//   }
// };

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return null;
    }
    const token = await getToken(messaging);
    return token;
  } catch (err) {
    console.error("FCM token error:", err);
    return null;
  }
};
